// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-typography-review_container__6dKeO","downloadButton":"business-resource-typography-review_downloadButton__rHCTR"};